<div style="padding: 16px; margin:1em;">
  <markdown [src] = "'assets/'+snippet.snippet">
  </markdown>
</div>

